import { render, staticRenderFns } from "./OfferCarouselItemTop.vue?vue&type=template&id=45cdfd1a&scoped=true&"
import script from "./OfferCarouselItemTop.vue?vue&type=script&lang=js&"
export * from "./OfferCarouselItemTop.vue?vue&type=script&lang=js&"
import style0 from "./OfferCarouselItemTop.vue?vue&type=style&index=0&id=45cdfd1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cdfd1a",
  null
  
)

export default component.exports